module.exports = __webpack_public_path__ + "img/Get-the-app-Popup-en.c35cf7a.png";